import { getTotalStatsTpl } from './../model/tpl/equip';
import { isDefined, not, notSingleEle, getDefined, truthy, each } from '../../../utils/util';
import { API_DOMAIN_DEFAULT } from '../../../model/model';

class TotalStat {
  constructor(options) {
    const _ = this;

    if (not(isDefined)(options)) throw new Error('TotalStat constructor require options object');

    _.option = $.extend({
      wrap: null,
      apiDomain: API_DOMAIN_DEFAULT,
      searchApiDomain: API_DOMAIN_DEFAULT,
      data: null, // hp, mp, noEquipStats: {mainStat:{mainStat, itemAffectedStat}, subStat, formattedSubStat}, stats: {mainStat:{mainStat, itemAffectedStat}, subStat, formattedSubStat}
      global: window
    }, options);

    _.wrap = null;

    _.data = _.option.data;

    _.arrangedBaseStat = _.getEnumeratedStats(_.data.noEquipStats || _.data.stats); // {STR, DEX, INT, CON, WIS, CHA, DAMAGE_SHORT, HIT_SHORT, ...}

    _.changedFormattedStat = $.extend({}, _.arrangedBaseStat);

    _.savedChangedFormattedStat = null;

    _.global = _.option.global;

  }

  init() {
    const _ = this;

    _.wrap = $(_.option.wrap);

    if (notSingleEle(_.wrap)) throw new Error('wrap must be single element.');

    _.setInstance();

    return _;
  }

  setInstance() {
    const _ = this;

    _.setContentsTplByBaseStat();
    _.setBtns();
  }

  setContentsTplByBaseStat() {
    const _ = this;

    console.log('TotalStat.js > setContentsTplByBaseStat() arrangedBaseStat :', _.arrangedBaseStat);
    console.log('TotalStat.js > setContentsTplByBaseStat() _.data : ', _.data );


    const tplFunc = doT.template(getTotalStatsTpl()),
      tpl = tplFunc($.extend(_.arrangedBaseStat, {
        hp: _.data.hp,
        mp: _.data.mp
      }));

    if ($('.totalstat', _.wrap).length <= 0) {
      _.wrap.append(tpl);

    } else {
      $('.totalstat', _.wrap).replaceWith(tpl);
    }
  }

  setBtns() {
    const _ = this;

    $(_.wrap).on('click', '.icon-close', function (evt) {
      evt.preventDefault();

      $(_).trigger({type: TotalStat.EVT_CLOSE});
    });
  }

  getEnumeratedStats(stats = {mainStat: {mainStat: {}, itemAffectedStat: {}}, subStat: {}, formattedSubStat: {}}) {
    const mainStat = stats.mainStat.mainStat,
      itemAffectedStat = stats.mainStat.itemAffectedStat,
      subStat = stats.formattedSubStat,
      attribute = getDefined(stats.formattedSubStat.attribute, null);

    let totalStats = {
      'STR': mainStat.STR - itemAffectedStat.STR,
      'DEX': mainStat.DEX - itemAffectedStat.DEX,
      'INT': mainStat.INT - itemAffectedStat.INT,
      'CON': mainStat.CON - itemAffectedStat.CON,
      'WIS': mainStat.WIS - itemAffectedStat.WIS,
      'CHA': mainStat.CHA - itemAffectedStat.CHA,

      // STR
      'DAMAGE_SHORT': subStat.STR.damageShort,
      'HIT_SHORT': subStat.STR.hitShort,
      'FATAL_SHORT': subStat.STR.fatalShort,
      'WEIGHT': subStat.STR.weight,

      // INT
      'DAMAGE_WIZ': subStat.INT.damageWiz,
      'HIT_WIZ': subStat.INT.hitWiz,
      'FATAL_WIZ': subStat.INT.fatalWiz,
      'MB': subStat.INT.mb,
      'MP_MINUS': subStat.INT.mpMinus,

      // DEX
      'DAMAGE_LONG': subStat.DEX.damageLong,
      'HIT_LONG': subStat.DEX.hitLong,
      'FATAL_LONG': subStat.DEX.fatalLong,
      'AC': subStat.DEX.ac,
      'ER': subStat.DEX.er,

      // WIS
      'LEVELUP_MP_PLUS': `${subStat.WIS.levelupMpPlus.min}~${subStat.WIS.levelupMpPlus.max}`,
      'MP_RECOVER_TIC': subStat.WIS.mpRecoverTic,
      'MP_RECOVER_LIQUOR': subStat.WIS.mpRecoverLiquor,
      'MR': subStat.WIS.mr,

      // CON
      'LEVELUP_HP_PLUS': `${subStat.CON.hpPlus.min}~${subStat.CON.hpPlus.max}`,
      'HP_RECOVER_TIC': `${subStat.CON.hpRecoverTic.min}~${subStat.CON.hpRecoverTic.max}`,
      'HP_RECOVER_LIQUOR': subStat.CON.hpRecoverLiquor,
      // CON WEIGHT === STR WEIGHT

      // CHA  // 20211206
      'CHA_HIT_SIKII': subStat.CHA.hitSkill,
      'CHA_HIT_SUMMON': subStat.CHA.hitSummon,
      'CHA_HIT_DRAGON': subStat.CHA.hitDragon,
      'CHA_HIT_FEAR': subStat.CHA.hitFear,
      'CHA_SKILL_TIME_REDUCTION': subStat.CHA.skillTimeReduction,
      'CHA_STATUS_TIME_REDUCTION': subStat.CHA.statusTimeReduction,

      // etc
      'SP': subStat.sp,
      'DAMAGE_MINUS': subStat.damageMinus,
      'MAX_HP_PLUS': subStat.maxHpPlus,
      'MAX_MP_PLUS': subStat.maxMpPlus,

      // attribute
      'FIRE': attribute.fire,
      'WATER': attribute.water,
      'STORM': attribute.storm,
      'LAND': attribute.land,
      'HIT_SKILL': attribute.hitSkill,
      'RES_SKILL': attribute.resSkill,
      'HIT_SUMMON': attribute.hitSummon,
      'RES_SUMMON': attribute.resSummon,
      'HIT_DRAGON': attribute.hitDragon,
      'RES_DRAGON': attribute.resDragon,
      'HIT_FEAR': attribute.hitFear,
      'RES_FEAR': attribute.resFear
    };

    for (let key in totalStats) {
      if (not(isDefined)(totalStats[key])) totalStats[key] = '-';
    }

    return totalStats;
  }

  setChangedStats(data = {mainStat: {mainStat: {}, itemAffectedStat: {}}, subStat: {}, formattedSubStat: {}}) {
    console.log('setChangedStats - data :', data);
    const _ = this;

    _.setContentsTplByBaseStat();

    const previousTotalStats = $.extend({}, _.arrangedBaseStat),
      receiveStats = _.getArrangedData(data),
      changedTotalStats = _.getChangedTotalStats(previousTotalStats, receiveStats);
    console.log('changedTotalStats :', changedTotalStats);

    let list;
    for (let key in changedTotalStats) {
      if (isDefined(changedTotalStats[key])) {
        list = $(`.${key}`, _.wrap);

        if (list.length >= 0) $(`.${key} .total`, _.wrap).text(changedTotalStats[key]);
      }
    }

    let statList, baseVal, totalNode;
    for (let key in _.arrangedBaseStat) {
      statList = $(`.${key}`, _.wrap);

      baseVal = _.arrangedBaseStat[key];

      totalNode = $($('var .total', statList).get(0));
      (totalNode.text() === String(baseVal)) ? statList.removeClass('diff') : statList.addClass('diff');
    }

    _.changedFormattedStat = receiveStats;

    console.log('changedFormattedStat :', _.changedFormattedStat);
  }

  getArrangedData(data = null) {
    let arragedData = {
      'STR': '-',
      'DEX': '-',
      'INT': '-',
      'CON': '-',
      'WIS': '-',
      'CHA': '-',

      // STR
      'DAMAGE_SHORT': '-',
      'HIT_SHORT': '-',
      'FATAL_SHORT': '-',
      'WEIGHT': '-',

      // INT
      'DAMAGE_WIZ': '-',
      'HIT_WIZ': '-',
      'FATAL_WIZ': '-',
      'MB': '-',
      'MP_MINUS': '-',

      // DEX
      'DAMAGE_LONG': '-',
      'HIT_LONG': '-',
      'FATAL_LONG': '-',
      'AC': '-',
      'ER': '-',

      // WIS
      'LEVELUP_MP_PLUS': '-',
      'MP_RECOVER_TIC': '-',
      'MP_RECOVER_LIQUOR': '-',
      'MR': '-',

      // CON
      'LEVELUP_HP_PLUS': '-',
      'HP_RECOVER_TIC': '-',
      'HP_RECOVER_LIQUOR': '-',
      // CON WEIGHT === STR WEIGHT

      // CHA
      // CHA has no sub attribute.

      'SP': '-',
      'DAMAGE_MINUS': '-',
      'MAX_HP_PLUS': '-',
      'MAX_MP_PLUS': '-',

      'FIRE': '-',
      'WATER': '-',
      'STORM': '-',
      'LAND': '-',
      'HIT_SKILL': '-',
      'RES_SKILL': '-',
      'HIT_SUMMON': '-',
      'RES_SUMMON': '-',
      'HIT_DRAGON': '-',
      'RES_DRAGON': '-',
      'HIT_FEAR': '-',
      'RES_FEAR': '-'
    };

    if (isDefined(data)) {
      const mainStat = data.mainStat.mainStat,
        subStat = data.formattedSubStat,
        attribute = getDefined(data.formattedSubStat.attribute, null);

      arragedData = {
        'STR': mainStat.STR,
        'DEX': mainStat.DEX,
        'INT': mainStat.INT,
        'CON': mainStat.CON,
        'WIS': mainStat.WIS,
        'CHA': mainStat.CHA,

        // STR
        'DAMAGE_SHORT': subStat.STR.damageShort,
        'HIT_SHORT': subStat.STR.hitShort,
        'FATAL_SHORT': subStat.STR.fatalShort,
        'WEIGHT': subStat.STR.weight,

        // INT
        'DAMAGE_WIZ': subStat.INT.damageWiz,
        'HIT_WIZ': subStat.INT.hitWiz,
        'FATAL_WIZ': subStat.INT.fatalWiz,
        'MB': subStat.INT.mb,
        'MP_MINUS': subStat.INT.mpMinus,

        // DEX
        'DAMAGE_LONG': subStat.DEX.damageLong,
        'HIT_LONG': subStat.DEX.hitLong,
        'FATAL_LONG': subStat.DEX.fatalLong,
        'AC': subStat.DEX.ac,
        'ER': subStat.DEX.er,

        // WIS
        'LEVELUP_MP_PLUS': `${subStat.WIS.levelupMpPlus.min}~${subStat.WIS.levelupMpPlus.max}`,
        'MP_RECOVER_TIC': subStat.WIS.mpRecoverTic,
        'MP_RECOVER_LIQUOR': subStat.WIS.mpRecoverLiquor,
        'MR': subStat.WIS.mr,

        // CON
        'LEVELUP_HP_PLUS': `${subStat.CON.hpPlus.min}~${subStat.CON.hpPlus.max}`,
        'HP_RECOVER_TIC': `${subStat.CON.hpRecoverTic.min}~${subStat.CON.hpRecoverTic.max}`,
        'HP_RECOVER_LIQUOR': subStat.CON.hpRecoverLiquor,
        // CON WEIGHT === STR WEIGHT

        // CHA  // 20211206
        'CHA_HIT_SIKII': subStat.CHA.hitSkill,
        'CHA_HIT_SUMMON': subStat.CHA.hitSummon,
        'CHA_HIT_DRAGON': subStat.CHA.hitDragon,
        'CHA_HIT_FEAR': subStat.CHA.hitFear,
        'CHA_SKILL_TIME_REDUCTION': subStat.CHA.skillTimeReduction,
        'CHA_STATUS_TIME_REDUCTION': subStat.CHA.statusTimeReduction,

        // etc
        'SP': subStat.sp,
        'DAMAGE_MINUS': subStat.damageMinus,
        'MAX_HP_PLUS': subStat.maxHpPlus,
        'MAX_MP_PLUS': subStat.maxMpPlus,

        // attritube
        'FIRE': (isDefined(attribute)) ? getDefined(attribute.fire, '-') : '-',
        'WATER': (isDefined(attribute)) ? getDefined(attribute.water, '-') : '-',
        'STORM': (isDefined(attribute)) ? getDefined(attribute.storm, '-') : '-',
        'LAND': (isDefined(attribute)) ? getDefined(attribute.land, '-') : '-',
        'HIT_SKILL': isDefined(attribute) ? getDefined(attribute.hitSkill, '-') : '-',
        'RES_SKILL': isDefined(attribute) ? getDefined(attribute.resSkill, '-') : '-',
        'HIT_SUMMON': isDefined(attribute) ? getDefined(attribute.hitSummon, '-') : '-',
        'RES_SUMMON': isDefined(attribute) ? getDefined(attribute.resSummon, '-') : '-',
        'HIT_DRAGON': isDefined(attribute) ? getDefined(attribute.hitDragon, '-') : '-',
        'RES_DRAGON': isDefined(attribute) ? getDefined(attribute.resDragon, '-') : '-',
        'HIT_FEAR': isDefined(attribute) ? getDefined(attribute.hitFear, '-') : '-',
        'RES_FEAR': isDefined(attribute) ? getDefined(attribute.resFear, '-') : '-'
      };
    }

    return arragedData;
  }

  getChangedTotalStats(originalStats, newStats) {
    let changedStats = {};

    var originalStat, newStat;
    for (let key in originalStats) {
      originalStat = originalStats[key];
      newStat = newStats[key];

      if (isDefined(newStat)) {
        if (originalStat !== newStat) changedStats[key] = newStat;
      }
    }

    let changedStatCount = 0;
    for (let i in changedStats) changedStatCount++;

    if (changedStatCount > 0) return changedStats;

    return null;
  }

  getBaseMainStats() {
    return {
      STR: this.arrangedBaseStat.STR,
      DEX: this.arrangedBaseStat.DEX,
      INT: this.arrangedBaseStat.INT,
      CON: this.arrangedBaseStat.CON,
      WIS: this.arrangedBaseStat.WIS,
      CHA: this.arrangedBaseStat.CHA
    }
  }

  /*
   getTotalStats() {
   const _ = this;

   let stats = $.extend({}, this.arrangedBaseStat);

   stats.STR = _.arrangedBaseStat.STR;
   stats.INT = _.arrangedBaseStat.INT;
   stats.DEX = _.arrangedBaseStat.DEX;
   stats.WIS = _.arrangedBaseStat.WIS;
   stats.CON = _.arrangedBaseStat.CON;
   stats.CHA = _.arrangedBaseStat.CHA;

   return stats;
   }
   */

  restoreAllStats() {
    const _ = this;

    let statList;
    for (let key in _.savedChangedFormattedStat) {
      statList = $(`.${key}`, _.wrap);

      statList.removeClass('diff');

      $('.total', statList).text(_.savedChangedFormattedStat[key]);
    }
  }

  saveCurrentAllStatus() {
    const _ = this;

    _.savedChangedFormattedStat = {
      'STR': $('.STR .total', _.wrap).text(),
      'DEX': $('.DEX .total', _.wrap).text(),
      'INT': $('.INT .total', _.wrap).text(),
      'CON': $('.CON .total', _.wrap).text(),
      'WIS': $('.WIS .total', _.wrap).text(),
      'CHA': $('.CHA .total', _.wrap).text(),

      // STR
      'DAMAGE_SHORT': $('.DAMAGE_SHORT .total', _.wrap).text(),
      'HIT_SHORT': $('.HIT_SHORT .total', _.wrap).text(),
      'FATAL_SHORT': $('.FATAL_SHORT .total', _.wrap).text(),
      'WEIGHT': $($('.WEIGHT .total', _.wrap).get(0)).text(),

      // INT
      'DAMAGE_WIZ': $('.DAMAGE_WIZ .total', _.wrap).text(),
      'HIT_WIZ': $('.HIT_WIZ .total', _.wrap).text(),
      'FATAL_WIZ': $('.FATAL_WIZ .total', _.wrap).text(),
      'MB': $('.MB .total', _.wrap).text(),
      'MP_MINUS': $('.MP_MINUS .total', _.wrap).text(),

      // DEX
      'DAMAGE_LONG': $('.DAMAGE_LONG .total', _.wrap).text(),
      'HIT_LONG': $('.HIT_LONG .total', _.wrap).text(),
      'FATAL_LONG': $('.FATAL_LONG .total', _.wrap).text(),
      'AC': $('.AC .total', _.wrap).text(),
      'ER': $('.ER .total', _.wrap).text(),

      // WIS
      'LEVELUP_MP_PLUS': $('.LEVELUP_MP_PLUS .total', _.wrap).text(),
      'MP_RECOVER_TIC': $('.MP_RECOVER_TIC .total', _.wrap).text(),
      'MP_RECOVER_LIQUOR': $('.MP_RECOVER_LIQUOR .total', _.wrap).text(),
      'MR': $('.MR .total', _.wrap).text(),

      // CON
      'LEVELUP_HP_PLUS': $('.LEVELUP_HP_PLUS .total', _.wrap).text(),
      'HP_RECOVER_TIC': $('.HP_RECOVER_TIC .total', _.wrap).text(),
      'HP_RECOVER_LIQUOR': $('.HP_RECOVER_LIQUOR .total', _.wrap).text(),
      // CON WEIGHT === STR WEIGHT

      // CHA  // 20211206
      'CHA_HIT_SIKII': $('.CHA_HIT_SIKII .total', _.wrap).text(),
      'CHA_HIT_SUMMON': $('.CHA_HIT_SUMMON .total', _.wrap).text(),
      'CHA_HIT_DRAGON': $('.CHA_HIT_DRAGON .total', _.wrap).text(),
      'CHA_HIT_FEAR': $('.CHA_HIT_FEAR .total', _.wrap).text(),
      'CHA_SKILL_TIME_REDUCTION': $('.CHA_SKILL_TIME_REDUCTION .total', _.wrap).text(),
      'CHA_STATUS_TIME_REDUCTION': $('.CHA_STATUS_TIME_REDUCTION .total', _.wrap).text(),

      // etc
      'SP': $('.SP .total', _.wrap).text(),
      'DAMAGE_MINUS': $('.DAMAGE_MINUS .total', _.wrap).text(),
      'MAX_HP_PLUS': $('.MAX_HP_PLUS .total', _.wrap).text(),
      'MAX_MP_PLUS': $('.MAX_MP_PLUS .total', _.wrap).text(),

      // attribute
      'FIRE': $('.FIRE .total', _.wrap).text(),
      'WATER': $('.WATER .total', _.wrap).text(),
      'STORM': $('.STORM .total', _.wrap).text(),
      'LAND': $('.LAND .total', _.wrap).text(),
      'HIT_SKILL': $('.HIT_SKILL .total', _.wrap).text(),
      'RES_SKILL': $('.RES_SKILL .total', _.wrap).text(),
      'HIT_SUMMON': $('.HIT_SUMMON .total', _.wrap).text(),
      'RES_SUMMON': $('.RES_SUMMON .total', _.wrap).text(),
      'HIT_DRAGON': $('.HIT_DRAGON .total', _.wrap).text(),
      'RES_DRAGON': $('.RES_DRAGON .total', _.wrap).text(),
      'HIT_FEAR': $('.HIT_FEAR .total', _.wrap).text(),
      'RES_FEAR': $('.RES_FEAR .total', _.wrap).text()
    };
  }

  resetDiffAtAllStats() {
    const _ = this;

    let $list;
    for (let key in _.arrangedBaseStat) {
      if (isDefined(_.arrangedBaseStat[key])) {
        $list = $(`.${key}`, _.wrap);
        $list.removeClass('diff');
      }
    }
  }

  setDiffByCompareSavedFormattedStatAndNewStats() {
    const _ = this;

    let changedStat, savedStat, $list;
    for (let key in _.changedFormattedStat) {
      changedStat = String(_.changedFormattedStat[key]);
      savedStat = String(_.savedChangedFormattedStat[key]);

      $list = $(`.${key}`, _.wrap);

      (changedStat !== savedStat) ? $list.addClass('diff') : $list.removeClass('diff');
    }
  }

  displayAffectStats(stats = []) { // ['AC', 'DEX', ...]
    const _ = this;

    if (not(Array.isArray)(stats)) return;

    if (stats.length <= 0) {
      for (let key in _.arrangedBaseStat) {
        $(`.${key}`, _.wrap).removeClass('active');
      }

    } else {
      each(stats, (stat) => $(`.${stat}`, _.wrap).addClass('active'));
    }
  }

  showTotalStat(flag) {
    const _ = this,
      totalStat = $('.totalstat', _.wrap);

    (truthy(flag)) ? totalStat.show() : totalStat.hide();
  }

  destroy(obj = null) {
    const _ = this;

    _.savedChangedFormattedStat = null;

    _.changedFormattedStat = null;
  }

  /*
   * by external
   */
  resetShowTotalStat() {
    $('.totalstat', this.wrap).css({display: ''});
  }
}

TotalStat.EVT_CLOSE = 'EVT_CLOSE';

export default TotalStat;


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/equip/TotalStat.js